
import { Action } from "../../types/Action";
import settings from "settings";
import { SEARCH_CHANGE_BATTLE_TYPE, SEARCH_CHANGE_PAGE, SEARCH_CHANGE_TERM, SEARCH_CLEAR_STATE, SEARCH_START_FETCHING, SEARCH_UPDATE_ERROR, SEARCH_UPDATE_RESULT } from "../Actions/ActionSearch";

import { APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS } from "../Actions/ActionApp";

export type State = {};

let initialState: State = {
  battleTypeSelected: settings.defaultBattleType,
  error: null,
  isFetchedBefore: false,
  isFetching: false,
  items: [],
  meta: null,
  page: 1,
  term: ''
};

export type IReducerSearch = (state: State, action: Action) => State;
export const ReducerSearch = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    default:
      return state;

  }
};

export const searchResult = (state: State = initialState, action: Action) => {
  switch (action.type) {
    case SEARCH_CHANGE_BATTLE_TYPE:
      return Object.assign({}, state, {
        battleTypeSelected: action.battleType
      });
    case SEARCH_CHANGE_PAGE:
      return Object.assign({}, state, {
        page: action.page
      });
    case SEARCH_CHANGE_TERM:
      return Object.assign({}, state, {
        term: action.term,
        page: 1,
        items: []
      });
    case SEARCH_CLEAR_STATE:
      return initialState;
    case SEARCH_START_FETCHING:
      return Object.assign({}, state, {
        isFetchedBefore: true,
        isFetching: true
      });
    case SEARCH_UPDATE_ERROR:
      return Object.assign({}, state, {
        isFetching: false,
        items: [],
        meta: null,
        error: action.error
      });
    case SEARCH_UPDATE_RESULT:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.data.clans,
        meta: action.data._meta_,
        error: null
      });
    case APPLICATIONS_UPDATE_CLAN_ACTIVE_APPLICATIONS:
      return Object.assign({}, state, {
        items: state.items.map(clan => {
          return clan.id === action.clanId ? {
            ...clan,
            has_application: true
          } : clan;
        })
      });
    default:
      return state;

  }
};